import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";

require('./planning-draft-resources-table-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-resources-table-list-item',
  templateUrl: './planning-draft-resources-table-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftResourcesTableListItemComponent {
  @Input() resource: any;
  @Input() settings: any;
  @Input() isSelected: boolean;
  @Input() canClose: boolean;
  @Input() itemElementSize: string;
  @Input() resourceRoutes: any[] = [];

  @Output() onDispatch = new EventEmitter<string[]>();
  @Output() onClose = new EventEmitter<void>();
  @Output() onToggleSelected = new EventEmitter<boolean>();
  @Output() onEditResourceAllocation = new EventEmitter<{ resource: any, route: any, event: any }>();

  constructor() {}

  getResourceTotalDuration() {
    return (this.resourceRoutes || []).reduce((acc, route) => acc + (route.totals?.totalTimeSec || 0), 0);
  }

  dispatchAll() {
    const ids = (this.resourceRoutes || []).map(r => r.id);
    this.onDispatch.emit(ids);
  }
}
